import axiosInstance from './axiosInstance'

/**
 * Login with username (or email) + password.
 * Returns { success, token, refreshToken, user, message }.
 */
export async function login(usernameOrEmail, password) {
  try {
    const response = await axiosInstance.post('/api/auth/login', {
      username: usernameOrEmail,
      password
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.response?.data || error.message || 'Login failed'
    throw new Error(errorMessage)
  }
}

/**
 * Register a new user.
 * Returns { success, token, refreshToken, user, message }.
 */
export async function register(userData) {
  try {
    const response = await axiosInstance.post('/api/auth/register', userData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Registration failed'
    throw new Error(errorMessage)
  }
}
